






























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PrintModalPO from "@/store/entities/basedata/printmodalpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getLodop } from "@/assets/lodop/lodopFun";
import lodoppo from "@/store/entities/Common/lodoppo";
import Util from "@/lib/util";
import printformat from "@/lib/Common/printformt";

@Component({
  components: { TreeSelect },
})
export default class EditPrintModal extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  printmodalpo: PrintModalPO = new PrintModalPO();
  lodoplist: Array<lodoppo> = [];
  loading: boolean = false;
  create() { }
  created() {
    this.printmodalpo.isEnable = 1;
    this.printmodalpo.modalInfo = null;
    this.getItemDetail();
    this.getcompanytree();
  }
  get list() {
    return this.$store.state.printmodal.list;
  }
  //保存
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let txt = document.getElementById("editmodalvalue") as HTMLInputElement;
        this.printmodalpo.modalInfo = txt.innerHTML;
        this.loading = true;
        await this.$store
          .dispatch({
            type: "printmodal/update",
            data: this.printmodalpo,
          })
          .then(() => {
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  //取消
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  //编辑模板
  editmodal() {
    const LODOP = getLodop();
    if (LODOP) {
      let txtedit = document.getElementById(
        "editmodalvalue"
      ) as HTMLInputElement;
      let val = txtedit.innerHTML;
      if (val.indexOf("LODOP") == -1) {
        val = this.printmodalpo.modalInfo;
      }
      if (val.indexOf("LODOP") == -1) {
        LODOP.PRINT_DESIGN();
      } else {
        this.lodoplist = printformat.lodopinfo(val);
        this.lodoplist.forEach((ele) => {
          switch (ele.key) {
            case "LODOP.PRINT_INIT": //打印初始化PRINT_INIT(strTaskName)
              LODOP.PRINT_INIT(ele.name);
              break;
            case "LODOP.PRINT_INITA": //(扩展型)打印初始化(Top,Left,Width,Height,strPrintName)
              LODOP.PRINT_INITA(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.name
              );
              break;
            case "LODOP.SET_PRINT_PAGESIZE": //设定纸张大小(intOrient, PageWidth,PageHeight,strPageName)
              LODOP.SET_PRINT_PAGESIZE(
                ele.intOrient,
                ele.intPageWidth,
                ele.intPageWidth,
                ele.strPageName
              );
              break;
            case "LODOP.ADD_PRINT_HTM": //增加超文本打印项(普通模式)(Top,Left,Width,Height,strHtmlContent)
              LODOP.ADD_PRINT_HTM(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_TEXT": //增加纯文本打印项(Top,Left,Width,Height,strContent)
              LODOP.ADD_PRINT_TEXT(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "ADD_PRINT_IMAGE": //增加图片打印项(Top,Left,Width,Height,strHtmlContent)
              LODOP.ADD_PRINT_IMAGE(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_RECT": //增加矩形线ADD_PRINT_RECT(Top, Left, Width, Height,intLineStyle, intLineWidth)
              LODOP.ADD_PRINT_RECT(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.intLineStyle,
                ele.intLineWidth
              );
              break;
            case "LODOP.ADD_PRINT_ELLIPSE": //增加椭圆线(Top, Left,Width, Height, intLineStyle, intLineWidth)
              LODOP.ADD_PRINT_ELLIPSE(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.intLineStyle,
                ele.intLineWidth
              );
              break;
            case "LODOP.ADD_PRINT_LINE": //增加直线(Top1,Left1, Top2, Left2,intLineStyle, intLineWidth),用intWidth,intHeight代替Top2,Left2
              LODOP.ADD_PRINT_LINE(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.intLineStyle,
                ele.intLineWidth
              );
              break;
            case "LODOP.ADD_PRINT_TEXTA": //(扩展型)增加纯文本打印项(strItemName,Top,Left,Width,Height,strContent)
              LODOP.ADD_PRINT_TEXTA(
                ele.name,
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_BARCODE": //增加条形码(Top, Left,Width, Height, CodeType, CodeValue)
              LODOP.ADD_PRINT_BARCODE(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.codeType,
                ele.codeValue
              );
              break;
            case "LODOP.ADD_PRINT_CHART": //增加图表(Top, Left,Width, Height, ChartType, strHtml)
              LODOP.ADD_PRINT_CHART(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.chartType,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_TABLE": //增加表格打印项（超文本模式）(Top,Left,Width,Height,strHtml)
              LODOP.ADD_PRINT_TABLE(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.LODOP.ADD_PRINT_URL": //增加超文本打印项（URL模式）(Top,Left,Width,Height,strURL)
              LODOP.ADD_PRINT_URL(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_SHAPE": //(扩展型)增加图形(intShapeType, Top, Left,Width,Height,intLineStyle,intLineWidth, varColor)
              LODOP.ADD_PRINT_SHAPE(
                ele.intShapeType,
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.intLineStyle,
                ele.intLineWidth,
                ele.intColor
              );
              break;
            case "LODOP.SET_PRINT_STYLE": //设置打印项风格(strStyleName,varStyleValue)
              LODOP.SET_PRINT_STYLE(ele.strStyleName, ele.varStyleValue);
              break;
            case "LODOP.SET_PRINT_STYLEA": //(扩展型)设置打印项风格A(varItemNameID, strStyleName,varStyleValue)
              LODOP.SET_PRINT_STYLEA(
                ele.varItemNameID,
                ele.strStyleName,
                ele.varStyleValue
              );
              break;
            case "LODOP.ADD_PRINT_HTML": //增加超文本打印项(图形模式)(Top,Left,Width,Height, strHtmlContent)
              LODOP.ADD_PRINT_HTML(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
            case "LODOP.ADD_PRINT_TBURL": //(扩展型)增加表格打印项（URL模式）(Top,Left,Width,Height,strURL)
              LODOP.ADD_PRINT_TBURL(
                ele.intTop,
                ele.intLeft,
                ele.intWidth,
                ele.intHeight,
                ele.strContent
              );
              break;
          }
        });
        LODOP.PRINT_DESIGN();
      }
      LODOP.On_Return = function (taskId, value) {
        txtedit.innerHTML = "";
        //console.log(val)
        txtedit.innerHTML = value.replace("\r", "");
      };
    }
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.printmodalpo = Util.extend(
        true,
        {},
        this.$store.state.printmodal.editItems
      );
    }
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 21;
      });
      info.forEach((ele) => {
        this.$data.modaltype.push({ label: ele.name, value: ele.id });
      });
    }
  }
  //获取公司树
  async getcompanytree() {
    await this.$store
      .dispatch("organization/getCommanySelectTree")
      .then((val) => {
        this.$data.companytree = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  //规则
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    modalInfo: [
      {
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    modalType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      companytree: [],
      modaltype: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isDisabled: node.type == 1 ? true : false,
        };
      },
    };
  }
}
